import { render, staticRenderFns } from "./ModalEnderecoEletronicoAdicionar.vue?vue&type=template&id=33ebba6c&scoped=true"
import script from "./ModalEnderecoEletronicoAdicionar.vue?vue&type=script&lang=js"
export * from "./ModalEnderecoEletronicoAdicionar.vue?vue&type=script&lang=js"
import style0 from "./ModalEnderecoEletronicoAdicionar.vue?vue&type=style&index=0&id=33ebba6c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33ebba6c",
  null
  
)

export default component.exports